const google = window.google

const getDistanceBetweenCoordsWGS84 = (loc1, loc2) => {
	const gLoc1 = new google.maps.LatLng(loc1[1], loc1[0])
	const gLoc2 = new google.maps.LatLng(loc2[1], loc2[0])
	return (google.maps.geometry.spherical.computeDistanceBetween(gLoc1, gLoc2) / 1000).toFixed()
}

export { getDistanceBetweenCoordsWGS84 }



// WEBPACK FOOTER //
// ./src/utils/DistanceUtils.js